import React from 'react';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { fi } from 'date-fns/locale';
import styles from '../Consumption/styles/Consumption.module.scss';

import { OmaLummeApp, ConsumptionApp } from '../../omaLummeContext';

import Box from '../Common/Box';
import WeightedAverageGraph from '../Graphs/WeightedAverageGraph';

// Utils.
import { setPriceFormat, roundNumber } from '../../utils/billing';
import { isActiveUserB2B } from '../../utils/customer';

const WeightedAverage: React.FunctionComponent = () => {
  const { t } = useTranslation();

  const { config, users } = OmaLummeApp.useState();
  const { activeFilter, consumptionEstimate, consumptionAvg, startDate, totalConsumption, weightedAvg } = ConsumptionApp.useState();

  const consumption = consumptionEstimate > totalConsumption ? consumptionEstimate : totalConsumption;

  const moneySaved = weightedAvg
    ? (consumption * weightedAvg[0][isActiveUserB2B(users) ? 'avgPrice' : 'avgPriceWithVat'] -
        consumption * weightedAvg[0][isActiveUserB2B(users) ? 'avgSpotPrice' : 'avgSpotPriceWithVat']) /
      100
    : 0;
  return (
    <>
      {config?.weightedAverage === true &&
        weightedAvg &&
        weightedAvg.length > 0 &&
        consumptionAvg &&
        consumptionAvg.averages.datePartAverages.length > 0 &&
        startDate &&
        activeFilter === 'month' && (
          <Box>
            {
              <h2 className="h1">{`${t('consumption:weightedAvg.title')} ${format(startDate, 'LLLL', { locale: fi })}${t(
                'consumption:weightedAvg.titleSuffix',
              )}`}</h2>
            }
            <div className={styles.weightedAvg}>
              <div>
                <div className={styles.weightedAvgValues}>
                  <div>
                    <p>{t('consumption:weightedAvg.weightedAvg')}</p>
                    <span className="h2">
                      {setPriceFormat(roundNumber(isActiveUserB2B(users) ? weightedAvg[0].avgPrice : weightedAvg[0].avgPriceWithVat))}{' '}
                      {t('consumption:nordPoolGraph.spotUnit')}
                    </span>
                  </div>
                  <div>
                    <p>{t('consumption:weightedAvg.spotAvg')}</p>
                    <span className="h2">
                      {setPriceFormat(roundNumber(isActiveUserB2B(users) ? weightedAvg[0].avgSpotPrice : weightedAvg[0].avgSpotPriceWithVat))}{' '}
                      {t('consumption:nordPoolGraph.spotUnit')}
                    </span>
                  </div>
                </div>

                <div className={styles.weightedAvgStats}>
                  <div className={styles.ranking}>
                    {t('consumption:weightedAvg.ranking')}
                    <span>Top {weightedAvg[0]['ranking%']} %</span>
                  </div>
                  <div className={styles.moneySaved}>
                    {t('consumption:weightedAvg.moneySaved')}
                    <span>
                      {moneySaved > 0 ? '+' : ''}
                      {setPriceFormat(roundNumber(moneySaved))} €
                    </span>
                  </div>
                  {weightedAvg[0].totalProfitableDaysInMonth !== undefined &&
                    weightedAvg[0].totalProfitableDaysInMonth !== null &&
                    weightedAvg[0].totalProfitableDaysInMonth > 0 && (
                      <div className={styles.belowDays}>
                        {t('consumption:weightedAvg.belowDays')}
                        <span>{weightedAvg[0].totalProfitableDaysInMonth}</span>
                      </div>
                    )}
                  {weightedAvg[0].longestStreakPerMonth !== undefined &&
                    weightedAvg[0].longestStreakPerMonth !== null &&
                    weightedAvg[0].longestStreakPerMonth > 0 && (
                      <div className={styles.streak}>
                        {t('consumption:weightedAvg.streak')}
                        <span>{weightedAvg[0].longestStreakPerMonth}</span>
                      </div>
                    )}
                </div>
              </div>

              <div className={styles.weightedAvgGraph}>
                <WeightedAverageGraph />
                <p>{t('consumption:weightedAvg.graphDisclaimer')}</p>
              </div>
            </div>
          </Box>
        )}
    </>
  );
};

export default WeightedAverage;
